// Keep native details navigation keyboard friendly and close it after selection.
document.addEventListener('click', (event) => {
  const menus = document.querySelectorAll('.ny-header__shop-menu[open], .ny-header__mobile-menu[open]');
  for (const menu of menus) {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.ny-header__shop-menu[open], .ny-header__mobile-menu[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
